import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { signIn as signInService, signOut as signOutService } from '@/services/auth.service';
import type { AppUser } from '@/types/domain';

interface AuthState {
  user: AppUser | null;
  status: 'idle' | 'loading' | 'error';
  error: string | null;
  signIn: (email: string, password: string) => Promise<AppUser>;
  signOut: () => void;
  setUser: (user: AppUser | null) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      status: 'idle',
      error: null,
      async signIn(email, password) {
        set({ status: 'loading', error: null });
        try {
          const user = await signInService(email, password);
          set({ user, status: 'idle', error: null });
          return user;
        } catch (err) {
          const message = err instanceof Error ? err.message : 'Sign in failed';
          set({ status: 'error', error: message });
          throw err;
        }
      },
      signOut() {
        void signOutService();
        set({ user: null, status: 'idle', error: null });
      },
      setUser(user) {
        set({ user });
      },
    }),
    {
      name: 'bpc.auth',
      partialize: (state) => ({ user: state.user }),
    },
  ),
);
